import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getVisualizations } from '../../../bundles/visualizations';
import { getVisualizationsPanelAdminSchema } from '../../panels/VisualizationsPanel';
import JSONEditor from '../../JSONEditor';

const VisualizationsSettings = ({ settings, onSave, onFullSettings, onClose }) => {
  const includedVisualizations = settings?.visualizations;
  const visualizations = useSelector(getVisualizations);
  const isExtraSmallHeight = settings?.height === 'extra-small';

  const vizIds = visualizations.map((v) => v.id);
  const updateIds = includedVisualizations?.filter((id) => vizIds.includes(id));

  const updatedSettings = { ...settings, visualizations: updateIds };

  const schema = useMemo(
    () => getVisualizationsPanelAdminSchema(visualizations, isExtraSmallHeight),
    [JSON.stringify(visualizations), isExtraSmallHeight]
  );

  return (
    <div className="column-content">
      <JSONEditor
        title="Visualizations: Options"
        schema={schema}
        formData={updatedSettings}
        onFormSubmit={onSave}
        onSecondaryAction={onFullSettings}
        cancelCallback={onClose}
        saveButtonText={'Save'}
        initialEditMode
        showEditButton={false}
      />
    </div>
  );
};

export default VisualizationsSettings;
